module.exports = __webpack_public_path__ + "images/knmv10ff68704333775613f21c66b439028d.png";